module.exports = __webpack_public_path__ + "static/media/OCV_Apps.dc08fc32.svg";